import isEmpty from 'lodash/isEmpty';

const empty = data => isEmpty(data);

export default empty;
